import { render, staticRenderFns } from "./setting_user.vue?vue&type=template&id=61842644&scoped=true"
import script from "./setting_user.vue?vue&type=script&lang=ts"
export * from "./setting_user.vue?vue&type=script&lang=ts"
import style0 from "./setting_user.vue?vue&type=style&index=0&id=61842644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61842644",
  null
  
)

export default component.exports